import React from "react";
import SkeletonBlock from "../common/SkeletonBlock";

function ProfileFieldSkeleton({ shortValue = false }) {
  return (
    <div className="border-b border-greyscale-1 space-y-2 py-2">
      <div className="flex items-start justify-between gap-4">
        <SkeletonBlock className="h-4 w-32 rounded-full" />
        <SkeletonBlock className="h-4 w-4 rounded-full shrink-0" />
      </div>
      <SkeletonBlock
        className={`h-5 rounded-full ${shortValue ? "w-24" : "w-40"}`}
      />
    </div>
  );
}

export default function ProfilePageLoadingShell() {
  return (
    <div
      aria-busy="true"
      data-testid="profile-page-skeleton"
      className="w-full max-w-lg h-full p-4 flex flex-col justify-start items-stretch gap-6"
    >
      <div className="flex items-center justify-between">
        <SkeletonBlock className="h-8 w-28 rounded-full" />
      </div>

      <section className="space-y-3">
        <SkeletonBlock className="h-5 w-28 rounded-full" />
        <SkeletonBlock className="h-4 w-full rounded-full" />
        <SkeletonBlock className="h-4 w-11/12 rounded-full" />
        <div className="space-y-1">
          <ProfileFieldSkeleton shortValue />
          <ProfileFieldSkeleton />
        </div>
      </section>

      <section className="space-y-3">
        <SkeletonBlock className="h-5 w-20 rounded-full" />
        <div className="space-y-1">
          {Array.from({ length: 4 }, (_, index) => (
            <ProfileFieldSkeleton
              key={index}
              shortValue={index % 2 === 0}
            />
          ))}
        </div>
      </section>

      <section className="border-b border-greyscale-1 space-y-3 py-2">
        <SkeletonBlock className="h-5 w-36 rounded-full" />
        <SkeletonBlock className="h-4 w-full rounded-full" />
        <SkeletonBlock className="h-4 w-4/5 rounded-full" />
        <div className="flex items-center justify-between gap-3 pt-1">
          <SkeletonBlock className="h-10 w-14 rounded-full" />
          <SkeletonBlock className="h-7 w-12 rounded-full" />
        </div>
      </section>
    </div>
  );
}
